"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIosVersion = void 0;
function getIosVersion(userAgent) {
    // Parses the major and minor version off the user agent data and converts it into a number
    const platformVersionMatchArray = userAgent.match(/OS (\w+)/) || [];
    const platformVersion = platformVersionMatchArray.length === 2 ? platformVersionMatchArray[1] : '';
    const platformVersionAsArray = platformVersion.split('_');
    const platformMajorVersion = parseInt(platformVersionAsArray[0]);
    const platformMinorVersion = parseInt(platformVersionAsArray[1]);
    return {
        major: platformMajorVersion,
        minor: platformMinorVersion,
    };
}
exports.getIosVersion = getIosVersion;
//# sourceMappingURL=get_ios_version.js.map